const __WEBPACK_NAMESPACE_OBJECT__ = require("live/components/actions/ui/confirmation-input-dialog");